import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-resend-mail',
  templateUrl: './resend-mail.component.html',
  styleUrls: ['./resend-mail.component.css']
})
export class ResendMailComponent implements OnInit {

  signLoader = false; captchaVal = false; captcha = "";
  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  resolved(res: string) {
		if (res != "") { this.captcha = res; this.captchaVal = true; }
	}

  submitFunc(login: NgForm) {			
		var data = login.value;
		// if (!this.captchaVal) {
		// 	return;
		// }
		this.captcha = "";		
		this.signLoader = true;
		this.conn.postUrl('users/forgotPassword', data).subscribe((res: any) => {
			if (res.status == 1) {
				this.alert.success('Reset Password link sent to your email');
			}else {
				this.alert.error(res.msg);
			}
			login.resetForm();
			this.signLoader = false;
		});		
			
	}

	removeSpace(event: any) {
		if (event.code === 'Space') {
			event.preventDefault();
		}
	}

}
